import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../../utility";
import Loader from "../../common/Loader";
import logo from "../../../asserts/logo.png";
import ReactToPrint from 'react-to-print';

function formateDate(dt){
    if(dt){
        console.log("Dt : ", dt);
        // let splitDateTime = dt?.split(' ');
        // let splitDate = splitDateTime[0]?.split('/');        
        // let date = new Date(splitDate[2]+"-"+splitDate[1]+"-"+splitDate[0]+" "+splitDateTime[1]);
        let date = new Date(dt);
        let formateDate = date.toISOString()?.split('T')[0];
        return formateDate;                
    }
}

function formateTime(dt){
    if(dt){
        // let splitDateTime = dt?.split(' ');
        // let splitDate = splitDateTime[0]?.split('/');        
        // let date = new Date(splitDate[2]+"-"+splitDate[1]+"-"+splitDate[0]+" "+splitDateTime[1]);
        let date = new Date(dt);
        let formateDate = date.toISOString()?.split('T')[1];
        let time = formateDate?.split('.')[0];
        return time;
    }
}

function currentDate(){
    const date = new Date();
    const formatedDate = date.toISOString().split('T')[0];
    return formatedDate;
}

const FundRequestDetail = () => {

    const [data, setData] = useState([]);

    const [user, setUser] = useState(null);

    const [loading, setLoading] = useState(true);
    
    const { id } = useParams();
    const navigate = useNavigate();

    const componentRef = useRef();
    const componentRef2 = useRef();

    useEffect(() => {
        const token = localStorage.getItem("admin_token");
        
        // console.log("token : ", token);
        axios.get(`${API_URL}/admin/view-request/${id}`, {headers: {'Authorization': `Bearer ${token}`}}).then((res) => {
            // console.log("Fund request detail : ", res);
            setData(res?.data?.fundView);
            setUser(res?.data?.fundView);
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            // console.log("Fund request detail error : ", err);
        })
    }, [])


    // useEffect(() => {
    //     const token = localStorage.getItem("admin_token");
    //     // console.log("token : ", token);
    //     axios.get(`${API_URL}/user/profile`, {headers: {'Authorization': `Bearer ${token}`}}).then((res) => {
    //         console.log("View User res : ", res);
    //         setUser(res?.data);
    //     }).catch((err) => {
    //         // console.log("View User error : ", err);
    //     })
    // }, [])
    


    return (
        <div className="staff-detail-page">
            {loading ? (
                <Loader />
            ) : (
            <>
                <div style={{ display: 'none' }}>
                    <ComponentToPrint amount={data?.fund_amount} ref={componentRef} />
                </div>
                <div style={{ display: 'none' }}>
                    <ComponentToPrintForBill amount={data?.fund_amount} ref={componentRef2} />
                </div>
                {/* im not using it, but it do exist -> {data?.request_id} */}
                
                <h1 className="staffName mt-3">{user?.user?.company}</h1>
                <h6 className="breadCrumbs mt-4 pb-3">
                    <span onClick={() => navigate(`/fund-requests`)} className="pointer">
                        Top Up List
                    </span>
                    <span className="greater-than"> &#62; </span>
                    <span className="viewUserText">{user?.user?.company}</span>
                </h6>

                <h3 className="staffdetail-sub-heading mt-4 mb-0">Top Up details</h3>
                <div className="d-flex mt-4">
                    <div className="div1 d-flex flex-column">

                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">Request Balance</p>
                            <p className="displayBlockText fw-bold">{Number(data?.fund_amount).toLocaleString()}</p>
                        </div>
                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">Date</p>
                            <p className="displayBlockText fw-bold">{formateDate(data?.created_at)}</p>
                        </div>
                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">Time</p>
                            <p className="displayBlockText fw-bold">{formateTime(data?.created_at)}</p>
                        </div>
                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">Transfer</p>
                            <p className="displayBlockText fw-bold">{data?.transfer_type}</p>
                        </div>
                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">Status</p>  
                            <p className="displayBlockText fw-bold">
                                <span className={data?.status === 'Success' ? "color-42c78f" 
                                    : data?.status === 'Failed'? "text-danger" 
                                    : data?.status === 'Pending' ? "text-warning" 
                                    : "text-secondary"}>{data?.status}</span>
                            </p>
                        </div>
                    </div>
                </div>
                
                <h3 className="staffdetail-sub-heading mt-4 mb-0">Download</h3>
                <div className="mt-4 d-flex">
                    <div className="div1">

                            <div className="d-flex flex-row align-items-center pt-2 pb-2">
                            <p className="displayBlockText">Download Quotation</p>
                            <ReactToPrint
                                    trigger={() => (
                                    <button className="pointerButton ms-4" style={{ width: '160px' }}>Quotation</button>
                                )}
                                content={() => componentRef.current}
                            />
                        </div>

                        <div className="d-flex flex-row align-items-center pt-2 pb-2">
                            <p className="displayBlockText">Download Bill</p>
                            <ReactToPrint
                                    trigger={() => (
                                    <button className="pointerButtonHollow ms-4" style={{ width: '160px' }}>Bill</button>
                                )}
                                content={() => componentRef2.current}
                            />
                        </div>
                    </div>
                </div>

                <h3 className="staffdetail-sub-heading mt-4 mb-0">User Detail</h3>
                <div className="d-flex mt-4">
                    <div className="div1">
                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">User account</p>
                            <p className="displayBlockText fw-bold">{user?.user?.user_account}</p>
                        </div>
                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">Status</p>
                            <p className="displayBlockText fw-bold color-42c78f">Active</p>
                        </div>
                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">Money</p>
                            <p className="displayBlockText fw-bold">{Number(Number(user?.user?.money).toFixed(2)).toLocaleString()}</p>
                        </div>
                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">VCard</p>
                            <p className="displayBlockText fw-bold">{user?.user?.vCard}</p>
                        </div>
                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">Name - Surname</p>
                            <p className="displayBlockText fw-bold">{user?.user?.name} {user?.user?.surename}</p>
                        </div>
                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">Address</p>
                            <p className="displayBlockText fw-bold">{user?.user?.address}</p>
                        </div>
                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">Email</p>
                            <p className="displayBlockText fw-bold">{user?.user?.email}</p>
                        </div>
                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">Phone</p>
                            <p className="displayBlockText fw-bold">{user?.user?.phone_number}</p>
                        </div>
                        <div className="d-flex flex-row align-items-center">
                            <p className="displayBlockText">Company</p>
                            <p className="displayBlockText fw-bold">{user?.user?.company}</p>
                        </div>
                    </div>
                </div>
                
                <h3 className="staffdetail-sub-heading mt-5 mb-0">Bill Information</h3>
                <div className="d-flex mt-4 mb-5">
                    <div className="div1">
                        <div className="d-flex flex-row align-items-center">

                            <p className="displayBlockText">Company</p>
                            <p className="displayBlockText fw-bold">{user?.user?.bill_info?.company_name ? user?.user?.bill_info?.company_name : 'N/A'}</p>
                        </div>
                        <div className="d-flex flex-row align-items-center">

                            <p className="displayBlockText">Company Address</p>
                            <p className="displayBlockText fw-bold">{user?.user?.bill_info?.company_address ? user?.user?.bill_info?.company_address : 'N/A'}</p>
                        </div>

                        <div className="d-flex flex-row align-items-center">

                            <p className="displayBlockText">Phone</p>
                            <p className="displayBlockText fw-bold">{user?.user?.bill_info?.company_phone ? user?.user?.bill_info?.company_phone : 'N/A'}</p>
                        </div>
                        <div className="d-flex flex-row align-items-center">

                            <p className="displayBlockText">TAX ID</p>
                            <p className="displayBlockText fw-bold">{user?.user?.bill_info?.company_tax_id ? user?.user?.bill_info?.company_tax_id : 'N/A'}</p>
                        </div>
                    </div>
                </div>
            </>)}

            {/* <div className="mb-5 pt-4">
                <button className="btn-3 mt-4">Edit</button>
            </div> */}
        </div>
    )
}

export default FundRequestDetail;




const ComponentToPrint = React.forwardRef(({amount}, ref) => {
    const [user, setUser] = useState(null);

    const {id} = useParams();

    useEffect(() => {
        const token = localStorage.getItem("admin_token");
        
        // console.log("token : ", token);
        axios.get(`${API_URL}/admin/view-request/${id}`, {headers: {'Authorization': `Bearer ${token}`}}).then((res) => {
            // console.log("Fund request detail : ", res);
            // setData(res?.data?.fundView);
            setUser(res?.data?.fundView);
            // setLoading(false);
        }).catch((err) => {
            // setLoading(false);
            // console.log("Fund request detail error : ", err);
        })
    }, [])

    // useEffect(() => {
    //     const token = localStorage.getItem("admin_token");
    //     // console.log("token : ", token);
    //     axios.get(`${API_URL}/user/profile`, {headers: {'Authorization': `Bearer ${token}`}}).then((res) => {
    //         console.log("View User res : ", res);
    //         setUser(res?.data);            
    //     }).catch((err) => {
    //         // console.log("View User error : ", err);
    //     })
    // }, [])

    return (
        <div className="w-100" ref={ref}>
            <div className="d-flex w-100 invoice-header px-4 py-3 pt-4">
                <div className="w-50">
                    <img src={logo} height={"125px"} alt="logo" />
                </div>
                <div className="w-50">
                    <div className="text-end">
                        <h2 className="mb-1 clr-303778 text-danger">Provincial Electricity Authority</h2>
                        <p className="mb-1 text-danger">200 Ngam Wong Wan Rd., Lat yao, Chatuchak Bangkok 10900</p>
                        {/* <p className="mb-1">(123) 456 -829</p> */}
                        <p className="mb-1 text-danger">(Tax ID No.) 09940001655</p>
                    </div>
                </div>
            </div>
            <div className="w-100 text-center">
                <h1 className="clr-303778 mb-1 text-danger">Quotation</h1>                            
            </div>
            <div className="d-flex w-100 px-4 py-3">
                <div className="w-50">
                    <div>                                    
                        <h2 className="mb-1 text-danger">{user?.user?.name}</h2>
                        <p className="mb-1 text-danger">{user?.user?.address}</p>
                        <p className="mb-1 text-danger">{user?.user?.email}</p>
                    </div>
                </div>
                <div className="w-50">
                    <div className="text-end"> 
                        <p className="mb-1 mt-2 text-danger">Date: {currentDate()}</p>
                    </div>
                </div>
            </div>
            <div className="w-100 px-4">
                <table className="pdf-table1">
                    <thead>
                        <tr>
                            <th className="text-danger">#</th>
                            <th className="text-danger">Description</th>
                            <th className="text-danger">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="bg-303778 bg-danger w-60px">01</td>
                            <td>
                                <h6 className="mb-1 text-danger">Fund Request</h6>
                                {/* <p className="displayBlockText">Fund request for staff</p> */}
                            </td>
                            <td className="bg-303778 bg-danger w-100px">฿{Number(amount).toLocaleString()}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="d-flex w-100 px-4 py-3 invoice-header">
                <div className="w-65">
                    {/* <h3 className="pt-4">Thank You</h3> */}
                </div>
                <div className="w-35">
                    <div>
                        <table className="pdf-table2">
                            <thead>
                                <tr className="bb-rgb-237">
                                    <th className="text-danger">SUBTOTAL</th>
                                    <th className="text-danger">฿{Number((amount - (amount * 0.07)).toFixed(2)).toLocaleString()}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="bb-303778">
                                    <th className="clr-303778 text-danger">TAX 7%</th>
                                    <th className="clr-303778 text-danger">฿{Number((amount * 0.07)?.toFixed(2)).toLocaleString()}</th>
                                </tr>
                                <tr>
                                    <th className="text-danger">GRAND TOTAL</th>
                                    <th className="text-danger">฿{Number((parseFloat(amount))?.toFixed(2)).toLocaleString()}</th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>            
        </div>
    )
}); 

const ComponentToPrintForBill = React.forwardRef(({amount}, ref) => {
    const [user, setUser] = useState(null);

    const {id} = useParams();

    useEffect(() => {
        const token = localStorage.getItem("admin_token");
        
        // console.log("token : ", token);
        axios.get(`${API_URL}/admin/view-request/${id}`, {headers: {'Authorization': `Bearer ${token}`}}).then((res) => {
            // console.log("Fund request detail : ", res);
            // setData(res?.data?.fundView);
            setUser(res?.data?.fundView);
            // setLoading(false);
        }).catch((err) => {
            // setLoading(false);
            // console.log("Fund request detail error : ", err);
        })
    }, [])

    return (
        <div className="w-100" ref={ref}>
            <div className="d-flex w-100 invoice-header px-4 py-3 pt-4">
                <div className="w-50">
                    <img src={logo} height={"125px"} alt="logo" />
                </div>
                <div className="w-50">
                    <div className="text-end">
                        <h2 className="mb-1 clr-303778 text-danger">Provincial Electricity Authority</h2>
                        <p className="mb-1 text-danger">200 Ngam Wong Wan Rd., Lat yao, Chatuchak Bangkok 10900</p>
                        {/* <p className="mb-1">(123) 456 -829</p> */}
                        <p className="mb-1 text-danger">(Tax ID No.) 09940001655</p>
                    </div>
                </div>
            </div>
            <div className="w-100 text-center ">
                <h1 className="clr-303778x mb-1 text-danger">Bill</h1>                            
            </div>
            <div className="d-flex w-100 px-4 py-3">
                <div className="w-50">
                    <div>                                    
                        <h2 className="mb-1 text-danger">{user?.user?.name}</h2>
                        <p className="mb-1 text-danger">{user?.user?.address}</p>
                        <p className="mb-1 text-danger">{user?.user?.email}</p>
                    </div>
                </div>
                <div className="w-50">
                    <div className="text-end">
                        <p className="mb-1 mt-2 text-danger">Date: {currentDate()}</p>
                    </div>
                </div>
            </div>
            <div className="w-100 px-4">
                <table className="pdf-table1">
                    <thead>
                        <tr>
                            <th className="text-danger">#</th>
                            <th className="text-danger">Description</th>
                            <th className="text-danger">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="bg-303778 w-60px bg-danger">01</td>
                            <td>
                                <h6 className="mb-1 text-danger">Fund Request</h6>
                                {/* <p className="displayBlockText">Fund request for staff</p> */}
                            </td>
                            <td className="bg-303778 bg-danger w-100px">฿{Number(amount).toLocaleString()}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="d-flex w-100 px-4 py-3">
                <div className="w-65">
                    {/* <h3 className="pt-4">Thank You</h3> */}
                </div>
                <div className="w-35">
                    <div>
                        <table className="pdf-table2">
                            <thead>
                                <tr className="bb-rgb-237">
                                    <th className="text-danger">SUBTOTAL</th>
                                    <th className="text-danger">฿{Number((amount - (amount * 0.07)).toFixed(2)).toLocaleString()}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="bb-303778">
                                    <th className="clr-303778 text-danger">TAX 7%</th>
                                    <th className="clr-303778 text-danger">฿{Number((amount * 0.07)?.toFixed(2)).toLocaleString()}</th>
                                </tr>
                                <tr>
                                    <th className="text-danger">GRAND TOTAL</th>
                                    <th className="text-danger">฿{Number((parseFloat(amount))?.toFixed(2)).toLocaleString()}</th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}); 














// import React from "react";


// const FundRequestDetail = () => {
//     return (
//         <div className="staff-detail-page">
//             <h1 className="staffdetail-t1">#q5d9fcf7</h1>
//             <h6 className="staffdetail-t2"> Fund request <span className="greater-than"> &#62; </span> <span className="staffdetail-t3">#q5d9fcf7</span></h6>
//             <h3 className="staffdetail-sub-heading mt-3 mb-0">Fund request details</h3>
//             <div className="d-flex mt-4 pt-2">
//                 <div className="div1">
//                     <p className="displayBlockText">Fund request</p>
//                     <p className="displayBlockText">Date</p>
//                     <p className="displayBlockText">Time</p>
//                     <p className="displayBlockText">Transfer</p>
//                     <p className="displayBlockText">Status</p>
//                     {/* <p className="displayBlockText">Email</p>
//                     <p className="displayBlockText">Phone</p>
//                     <p className="displayBlockText">V-Card</p>
//                     <p className="displayBlockText">V-Card status</p> */}
//                 </div>
//                 <div className="div2">
//                     <p className="displayBlockText">2,000,000</p>
//                     <p className="displayBlockText">18-09-2023</p>
//                     <p className="displayBlockText">18:30</p>
//                     <p className="displayBlockText">QR Code</p>
//                     <p className="mb-0 color-42c78f">Active</p>
//                     {/* <p className="displayBlockText">angleria_2539@gmail.com</p>
//                     <p className="displayBlockText">0889563324</p>
//                     <p className="displayBlockText">122546969998</p> */}
//                     {/* <p className="displayBlockText">
//                         <span className="color-42c78f">Verify</span>
//                         <button className="btn-2 ms-4">Re-verify</button>
//                     </p> */}
//                 </div>
//             </div>
            
//             <h3 className="staffdetail-sub-heading mt-5">Download QT/Bill</h3>
//             <div className="mt-4">
//                 <button className="btn-3">Quatation</button>
//                 <button className="btn-3 btn-5 ms-3">Bill</button>

//             </div>

//             <h3 className="staffdetail-sub-heading mt-5 mb-0">User Detail</h3>
//             <div className="d-flex mt-4 pt-2">
//                 <div className="div1">
//                     <p className="displayBlockText">User account</p>
//                     <p className="displayBlockText">Status</p>
//                     <p className="displayBlockText">Wallet</p>
//                     <p className="displayBlockText">Name - Surname</p>
//                     <p className="displayBlockText">Address</p>
//                     <p className="displayBlockText">Email</p>
//                     <p className="displayBlockText">Phone</p>
//                     <p className="displayBlockText">Company</p>
//                 </div>
//                 <div className="div2">
//                     <p className="displayBlockText">Kerry</p>
//                     <p className="mb-0 color-42c78f">Active</p>
//                     <p className="displayBlockText">2,000</p>
//                     <p className="displayBlockText">John Wick</p>
//                     <p className="displayBlockText">1663/404 Pattanakan Road Suanluang Suanluang Bangkok 10250</p>
//                     <p className="displayBlockText">design@trigongroup.net</p>
//                     <p className="displayBlockText">0892244956</p>
//                     <p className="displayBlockText">Kerry Express</p>
//                 </div>
//             </div>
            
//             <h3 className="staffdetail-sub-heading mt-5 mb-0">Bill Information</h3>
//             <div className="d-flex mt-4 pt-2">
//                 <div className="div1">
//                     <p className="displayBlockText">Company</p>
//                     <p className="displayBlockText">Company Address</p>
//                     <p className="displayBlockText">Phone</p>
//                     <p className="displayBlockText">TAX ID</p>
//                 </div>
//                 <div className="div2">
//                     <p className="displayBlockText">Kerry Express</p>
//                     <p className="displayBlockText">2,000</p>
//                     <p className="displayBlockText">1111/105 Baangrangmuang Ladpao Road Junkasem Jatujak Bangkok 10900</p>
//                     <p className="displayBlockText">025788877</p>
//                 </div>
//             </div>

//             {/* <div className="mb-5 pt-4">
//                 <button className="btn-3 mt-4">Edit</button>
//             </div> */}
//         </div>
//     )
// }

// export default FundRequestDetail;